import { coachApi } from '@shared/api/client';
import type { ThemeRecord } from './types';
import { adaptThemeRecord } from './adapters';

export const themesApi = {
  getActiveTheme: async (siteId: string): Promise<ThemeRecord> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/theme`);
    return adaptThemeRecord(raw);
  },
  updateActiveTheme: (
    siteId: string,
    data: {
      tokens_json: Record<string, unknown>;
      heading_font: string;
      body_font: string;
      dark_mode_enabled: boolean;
    }
  ): Promise<{ updated: boolean }> =>
    coachApi.put<{ updated: boolean }>(`/webbuilder/sites/${siteId}/theme`, data),
  getTheme: async (siteId: string, themeId: string): Promise<ThemeRecord> => {
    const raw = await coachApi.get<unknown>(`/webbuilder/sites/${siteId}/themes/${themeId}`);
    return adaptThemeRecord(raw);
  },
  updateTheme: async (siteId: string, themeId: string, data: Partial<ThemeRecord>): Promise<ThemeRecord> => {
    const raw = await coachApi.put<unknown>(`/webbuilder/sites/${siteId}/themes/${themeId}`, data);
    return adaptThemeRecord(raw);
  },
};

export const webbuilderApi = themesApi;
export type * from './types';
